import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TW3224Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TW3224IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_468)">
        <rect width="32" height="24" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V24H32V0H0Z"
          fill="#EF0000"
        />
        <mask
          id="mask0_1813_468"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="32"
          height="24"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H32V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1813_468)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V14H18V0H0Z"
            fill="#2E42A5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.72982 10.8108L7.24816 12.6594L6.88927 10.3177L4.68185 11.1777L5.54188 8.97029L3.2002 8.61139L5.04871 7.12973L3.2002 5.64807L5.54188 5.28917L4.68185 3.08176L6.88927 3.94178L7.24816 1.6001L8.72982 3.44861L10.2115 1.6001L10.5704 3.94178L12.7778 3.08176L11.9178 5.28917L14.2595 5.64807L12.4109 7.12973L14.2595 8.61139L11.9178 8.97029L12.7778 11.1777L10.5704 10.3177L10.2115 12.6594L8.72982 10.8108ZM8.72982 9.99207C10.3107 9.99207 11.5922 8.71056 11.5922 7.12973C11.5922 5.5489 10.3107 4.26738 8.72982 4.26738C7.14899 4.26738 5.86748 5.5489 5.86748 7.12973C5.86748 8.71056 7.14899 9.99207 8.72982 9.99207ZM11.0197 7.12973C11.0197 8.39439 9.99449 9.4196 8.72982 9.4196C7.46516 9.4196 6.43995 8.39439 6.43995 7.12973C6.43995 5.86506 7.46516 4.83985 8.72982 4.83985C9.99449 4.83985 11.0197 5.86506 11.0197 7.12973Z"
            fill="#FEFFFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1813_468">
          <rect width="32" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TW3224Icon;
